import { render, staticRenderFns } from "./GestioneGruppi.vue?vue&type=template&id=52a318e3&scoped=true&"
import script from "./GestioneGruppi.vue?vue&type=script&lang=js&"
export * from "./GestioneGruppi.vue?vue&type=script&lang=js&"
import style0 from "./GestioneGruppi.vue?vue&type=style&index=0&id=52a318e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a318e3",
  null
  
)

export default component.exports